import React from 'react';
import pluralize from 'pluralize';
import moment from 'moment';
import {
    Typography,
    Input,
    Checkbox,
    ListItemText,
    Select,
    MenuItem,
    FormControl,
} from '@mui/material';
import './filter-modal.scss';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { observer } from 'mobx-react';
import { Heading1, ThemedButton, InputLabel } from '@awarego-ui/components';

function FilterModal({
                         onRequestClose,
                         resultCount,
                         filters,
                         filterCount,
                         clearFilters,
                         hideDateFilters = false,
                     }) {
    return (
        <>
            <div className={'modal__header'}>
                <Heading1>Filters</Heading1>
                <img src="/static/img/close-dark.svg" alt="Close" onClick={onRequestClose} />
            </div>
            <div className={'modalContent'}>
                {filters.map((filter, index) =>
                    filter.options ? (
                        <FormControl key={index} variant="outlined" color="primary">
                            <InputLabel text={filter.label} />
                            <Select
                                multiple
                                value={filter.value}
                                onChange={(e) => filter.onChange(e.target.value)}
                                input={<Input />}
                                color="primary"
                                renderValue={(selected) =>
                                    filter.options
                                        .filter((opt) => selected.includes(opt.value))
                                        .map((opt) => opt.label)
                                        .join(', ')
                                }
                                MenuProps={{
                                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                    variant: 'menu',
                                    disableScrollLock: true,
                                    getContentAnchorEl: null,
                                }}
                            >
                                {filter.options.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                        <Checkbox
                                            checked={filter.value.includes(opt.value)}
                                            color="primary"
                                        />
                                        <ListItemText primary={opt.label} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : null
                )}


                {!hideDateFilters && (
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        {filters
                            .filter((f) => f.type === 'date')
                            .map((dateFilter, idx) => (
                                <div key={idx}>
                                    <InputLabel text={dateFilter.label} />
                                    <div className="date-pickers">
                                        <DatePicker
                                            value={dateFilter.startValue}
                                            onChange={dateFilter.onStartChange}
                                            format="L"
                                            showTodayButton
                                            clearable
                                            emptyLabel="From"
                                            maxDate={
                                                dateFilter.endValue
                                                    ? moment(dateFilter.endValue)
                                                    : undefined
                                            }
                                            maxDateMessage={`Set date earlier than (${moment(
                                                dateFilter.endValue
                                            ).format('L')})`}
                                            className={!dateFilter.startValue ? 'filter-empty-label' : ''}
                                        />
                                        <DatePicker
                                            value={dateFilter.endValue}
                                            onChange={dateFilter.onEndChange}
                                            format="L"
                                            showTodayButton
                                            clearable
                                            emptyLabel="To"
                                            minDate={
                                                dateFilter.startValue
                                                    ? moment(dateFilter.startValue)
                                                    : undefined
                                            }
                                            minDateMessage={`Set date later than (${moment(
                                                dateFilter.startValue
                                            ).format('L')})`}
                                            className={!dateFilter.endValue ? 'filter-empty-label' : ''}
                                        />
                                    </div>
                                </div>
                            ))}
                    </LocalizationProvider>
                )}
            </div>
            <div className={'modalFooter'}>
                <div className="d-flex flex-justify-between flex-fill">
                    <div className="d-flex flex-fill flex-column">
                        <Typography color="primary" style={{ fontWeight: filterCount === 0 ? 600 : 800 }}>
                            {filterCount} {pluralize('filter', filterCount)} added
                        </Typography>
                        <Typography>
                            {filterCount > 0 ? `${resultCount} ${pluralize('result', resultCount)}` : ''}
                        </Typography>
                    </div>
                    {filterCount > 0 && (
                        <ThemedButton
                            mode="secondary"
                            onClick={clearFilters}
                            text="Clear"
                            style={{ marginRight: '16px' }}
                        />
                    )}
                </div>
                <ThemedButton mode="primary" text="Done" onClick={onRequestClose} />
            </div>
        </>
    );
}

export default observer(FilterModal);
